import { firstConnexionPasswordDefinitionDto, loginDto } from "@/types/authservices.types";
import { Auth } from "aws-amplify";
import { apolloClient, clearStore } from "../../src/apollo.services";
import { CognitoUser } from "amazon-cognito-identity-js";
import { NotificationManager } from "./notifications/notificationManager";
import USER_PROVIDER from "../graphql/user/UserProvider.gql";

export abstract class AuthServices {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static async login({ email, password }: loginDto): Promise<CognitoUser | any> {
        await clearStore();
        if (!email || !password) {
            throw new Error("Missing parameters");
        }
        try {
            const emailLowerCase = email.toLowerCase();
            const user = await Auth.signIn(emailLowerCase, password);
            // AuthServices.setToken(user.signInUserSession.accessToken.jwtToken);
            return user;
        } catch (error) {
            if (error.code === "NotAuthorizedException") {
                throw new Error("Invalid credentials");
            }
            throw new Error("Error during login");
        }
    }

    // static async logout(reload: boolean = true) {
    static async logout() {
        // localStorage.removeItem("apollo-token");
        NotificationManager.deleteNotificationManager();

        // if (reload) {
        //     router.push({ name: "login" });
        // }

        // if (env.ENABLE_COGNITO) {
        try {
            await Auth.signOut();
        } catch (error) {
            console.log("error signing out: ", error);
        }
        // }
        // }

        try {
            console.log("logout - before clearStore");
            await clearStore();
            console.log("logout - after clearStore");
        } catch (error) {
            console.error(error);
        }
    }

    static async firstConnexionPasswordDefinition({
        userEmail,
        temporaryPassword,
        newPassword,
    }: firstConnexionPasswordDefinitionDto): Promise<void> {
        // debugger;
        if (!userEmail || !temporaryPassword || !newPassword) {
            throw new Error("Missing parameters");
        }
        try {
            await this.changeFirstConnexionPassword(
                userEmail.toLowerCase(),
                temporaryPassword,
                newPassword,
            );
        } catch (error) {
            throw new Error(error);
        }
        return;
    }

    static async changeFirstConnexionPassword(
        userEmail: string,
        _temporaryPassword: string,
        newPassword: string,
    ) {
        // debugger;
        try {
            const temporaryPassword = decodeURIComponent(_temporaryPassword);
            // debugger;
            const currentUser = await Auth.signIn(userEmail.toLowerCase(), temporaryPassword);
            await Auth.completeNewPassword(currentUser, newPassword);
            // await Auth.confirmSignUp(userEmail, temporaryPassword)
            // debugger;
        } catch (error) {
            // debugger;
            if (error.code === "UserNotFoundException") {
                throw new Error("User not found");
            } else if (error.code === "NotAuthorizedException") {
                throw new Error("Incorrect email or temporary password");
            } else if (error.code === "CodeMismatchException") {
                throw new Error("Incorrect temporary password");
            } else if (error.code === "ExpiredCodeException") {
                throw new Error("Temporary password expired");
            }
        }

        try {
            AuthServices.login({ email: userEmail.toLowerCase(), password: newPassword });
        } catch (error) {
            throw new Error(error);
        }
    }

    static async changePassword(
        previousPassword: string,
        newPassword: string,
        currentUserId: string = "",
    ): Promise<void> {
        console.info(currentUserId);
        try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            await Auth.changePassword(cognitoUser, previousPassword, newPassword);
        } catch (error) {
            if (error.code === "UserNotFoundException") {
                throw new Error("User not found");
            } else if (error.code === "NotAuthorizedException") {
                throw new Error("Incorrect email or temporary password");
            } else if (error.code === "CodeMismatchException") {
                throw new Error("Incorrect temporary password");
            } else if (error.code === "ExpiredCodeException") {
                throw new Error("Temporary password expired");
            }
        }
        return;
    }

    static async resendSignUp(email: string): Promise<void> {
        try {
            await Auth.resendSignUp(email.toLowerCase());
        } catch (error) {
            if (error.code === "UserNotFoundException") {
                throw new Error("User not found");
            }
            if (error.code === "InvalidParameterException") {
                throw new Error("Invalid parameter");
            }
            if (error.code === "LimitExceededException") {
                throw new Error("Limit exceeded");
            }
            if (error.code === "NotAuthorizedException") {
                throw new Error("Not authorized");
            }
            throw error;
        }
        return;
    }

    static async sendForgotPasswordEmail(email: string): Promise<void> {
        try {
            await Auth.forgotPassword(email.toLowerCase());
        } catch (error) {
            if (error.code === "UserNotFoundException") {
                throw new Error("User not found");
            }
            if (error.code === "InvalidParameterException") {
                throw new Error("Invalid parameter");
            }
            if (error.code === "LimitExceededException") {
                throw new Error("Limit exceeded");
            }
            if (error.code === "NotAuthorizedException") {
                throw new Error("Not authorized");
            }
            throw error;
        }
        return;
    }

    static async confirmForgotPassword(
        email: string,
        code: string,
        newPassword: string,
    ): Promise<void> {
        try {
            await Auth.forgotPasswordSubmit(email.toLowerCase(), code, newPassword);
        } catch (e) {
            if (e.code === "UserNotFoundException") {
                throw new Error("User not found");
            }
            if (e.code === "CodeMismatchException") {
                throw new Error("Incorrect code");
            }
            if (e.code === "ExpiredCodeException") {
                throw new Error("Code expired");
            }
            if (e.code === "InvalidParameterException") {
                throw new Error("Invalid parameter");
            }
            throw new Error("Error during forgot password confirmation");
        }
    }

    static async getSSOProviders(email: string): Promise<string> {
        const userProvider = await apolloClient.query({
            query: USER_PROVIDER,
            fetchPolicy: "network-only",
            variables: {
                email: email.toLowerCase(),
            },
        });
        return userProvider.data.userProvider.providerName;
    }

    static redirectToSSO(customProvider: string) {
        Auth.federatedSignIn({ customProvider });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static async currentAuthenticatedUser(): Promise<CognitoUser | any> {
        return await Auth.currentAuthenticatedUser();
    }

    static async getUserToken(): Promise<string> {
        let token = "";
        try {
            const currentSession = await Auth.currentSession();
            if (currentSession) {
                token = currentSession.getAccessToken().getJwtToken();
            }
        } catch (e) {}
        return token;
    }
}
